import Api from '@/Api';

export default class GroupApi extends Api {
  /**
   * Requests the API to send a list of class plans for the subgroup
   * @param {Object} params - key/value pair to be provided as url query parameters
   * @param {String} params.subGroupCk eg"57907"
   * @param {String} params.type this is optional.  If present, the ONLY valid value is "ADD"
   * @return {Promise} Promise with the results of the request or error
   */
  classPlans = params => {
    if (params.subGroupCk === undefined) {
      console.warn('Unable to get class plans, invalid subGroupCk', params);
      return;
    }

    return this.post(`/api/v1/private/groups/subgroups/classplans`, params);
  };

  /**
   * Requests the API to send groups that match
   * @param {Object} params - key/value pair to be provided as url query parameters
   * @param {String} params.id - groupId, eg"57907"
   * @return {Promise} Promise with the results of the request or error
   */
  search = params => {
    if (params.id === undefined) {
      throw new Error(
        "id groupId must be passed to the API, even if it's empty"
      );
    }

    return this.post('/api/v1/private/groups', params);
  };

  /**
   * Requests the API to send subgroup benefits
   * @param {Object} options - key/value pair to be provided as url query parameters
   * @param {String} options.groupCk eg "51287"
   * @param {String} options.subGroupCk eg "72316"
   * @return {Promise} Promise with the results of the request or error
   */
  benefits = (options = {}) => {
    if (options.groupCk === undefined) {
      throw new Error('Unable to get benefits, invalid groupCk');
    }

    if (options.subGroupCk === undefined) {
      throw new Error('Unable to get benefits, invalid subGroupCk');
    }

    return this.get(
      `/api/v1/private/groups/${options.groupCk}/subgroups/${options.subGroupCk}/benefits`,
      options.params
    );
  };

  /**
   * Requests the API to send subgroup benefits
   * @param {Object} options - key/value pair to be provided as url query parameters
   * @param {String} options.groupCk eg "51287"
   * @param {String} options.subGroupCk eg "72316"
   * @return {Promise} Promise with the results of the request or error
   */
  benefitsFromGroup = (options = {}) => {
    if (options.groupCk === undefined) {
      throw new Error('Unable to get benefits, invalid groupCk');
    }

    return this.get(
      `/api/v1/private/groups/${options.groupCk}/benefits`,
      options.params
    );
  };

  /**
   * Requests the API to send subgroup details
   * @param {Object} options - key/value pair to be provided as url query parameters
   * @param {String} options.groupCk eg "51287"
   * @param {String} options.subGroupCk eg "72316"
   * @return {Promise} Promise with the results of the request or error
   */
  subGroup = (options = {}) => {
    if (options.groupCk === undefined) {
      throw new Error('Unable to get subgroup details, invalid groupCk');
    }

    if (options.subGroupCk === undefined) {
      throw new Error('Unable to get subgroup details, invalid subGroupCk');
    }

    return this.post('/api/v1/private/groups/subgroups', options);
  };

  parentGroupSearch = (opts = {}) => {
    // Not being used
    if ((!opts.id && !opts.name) || (opts.id === '' && opts.name === '')) {
      throw new Error('must provide either name or id to search parent groups');
    }
    return this.post('/api/v1/private/groups/getdatabypagrck', {
      pagrName: opts.name,
      pagrCk: opts.id
    });
  };
}
